import React from "react";
import { motion } from "framer-motion";
import { LogoMark } from "./Logo";

export default function TakenCareOf() {
  return (
    <section
      className="py-24 lg:py-40 bg-[#FDFBF7]"
      data-testid="mission-section"
      id="mission"
    >
      <div className="max-w-[1240px] mx-auto px-6 lg:px-10">
        <div className="grid lg:grid-cols-12 gap-10 lg:gap-16 items-center">
          <div className="lg:col-span-7">
            <motion.div
              initial={{ opacity: 0, y: 10 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.7 }}
              className="eyebrow mb-6"
            >
              Notre approche · HMCD s'occupe de tout
            </motion.div>
            <motion.h2
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.9 }}
              className="font-serif-display text-[40px] sm:text-[56px] lg:text-[80px] leading-[0.98] tracking-tight text-[#0F172A] balance"
            >
              Avec HMCD,{" "}
              <em className="not-italic text-[#2D7A4D]">c'est réglé.</em>
            </motion.h2>
            <motion.p
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.9, delay: 0.15 }}
              className="mt-8 text-[17px] lg:text-[19px] leading-relaxed text-[#334155] max-w-xl"
            >
              Peu importe votre objectif, on vous couvre. De la conception de
              votre installation à la mise en relation avec nos techniciens,
              en passant par le montage financier et la maintenance — on retire
              les migraines, vous profitez des économies.
            </motion.p>

            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.9, delay: 0.3 }}
              className="mt-10 flex flex-wrap gap-4"
            >
              <button
                data-testid="mission-cta"
                onClick={() =>
                  document.getElementById("contact")?.scrollIntoView({ behavior: "smooth" })
                }
                className="btn-primary"
              >
                Notre mission
              </button>
              <button
                data-testid="mission-cta-secondary"
                onClick={() =>
                  document.getElementById("solutions")?.scrollIntoView({ behavior: "smooth" })
                }
                className="btn-ghost"
              >
                Découvrir les solutions
              </button>
            </motion.div>
          </div>

          <div className="lg:col-span-5">
            <motion.div
              initial={{ opacity: 0, scale: 0.95 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 1.1, ease: [0.22, 1, 0.36, 1] }}
              className="relative aspect-square rounded-3xl bg-[#0F172A] p-10 flex items-center justify-center overflow-hidden"
            >
              {/* grid bg */}
              <div
                className="absolute inset-0 opacity-[0.09]"
                style={{
                  backgroundImage:
                    "linear-gradient(#fdfbf7 1px, transparent 1px), linear-gradient(90deg, #fdfbf7 1px, transparent 1px)",
                  backgroundSize: "36px 36px",
                }}
              />
              <motion.div
                animate={{ rotate: 360 }}
                transition={{ duration: 60, repeat: Infinity, ease: "linear" }}
                className="relative"
              >
                <LogoMark size={220} />
              </motion.div>
              <div className="absolute bottom-8 left-8 right-8 flex items-center justify-between text-[#fdfbf7]">
                <div className="font-mono-tech text-[10px] uppercase tracking-[0.22em] opacity-70">
                  HM Conseil Digital
                </div>
                <div className="font-mono-tech text-[10px] uppercase tracking-[0.22em] opacity-70">
                  Depuis 2015
                </div>
              </div>
            </motion.div>
          </div>
        </div>
      </div>
    </section>
  );
}
